
    var riot = require('riot')
    
riot.tag2('select-group', '<dl class="cmn__select" data-name="{opts.key}"> <dt>{opts.name}</dt> <dd ref="dd"> <yield></yield> </dd> </dl>', 'select-group { display: table-row-group; } select-group dl { display: table-row; }', '', function(opts) {
    const self = this

    self.on('mount', () => {
      $('select', self.refs.dd) .each(function(){
        $(this).wrap('<div class="select-group"></div>')
      })
    })

});
    
  


// WEBPACK FOOTER //
// ./_src/riot/product/select-group.tag